import React from 'react';

import setActiveTopMenuDropdownOperation from 'editor/src/store/app/operation/setActiveTopMenuDropdownOperation';
import isTopMenuDropdownVisible from 'editor/src/store/app/selector/isTopMenuDropdownVisible';
import { TopMenuDropdown } from 'editor/src/store/app/types';
import setSidebarActiveTabByNameOperation from 'editor/src/store/editorModules/sidebar/operation/setSidebarActiveTabByNameOperation';
import setSidebarActiveTabOperation from 'editor/src/store/editorModules/sidebar/operation/setSidebarActiveTabOperation';
import isSidebarTabActive from 'editor/src/store/editorModules/sidebar/selector/isSidebarTabActive';
import { TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import IconStrokeWidth from 'editor/src/component/Icon/IconStrokeWidth';
import { MenuItemProps } from 'editor/src/component/Menu/type';
import MenuButton from 'editor/src/component/TopMenuDesktop/buttons/MenuButton';

type Props = Pick<MenuItemProps, 'mode' | 'close' | 'isMobile'>;

function ButtonRectangleStyles({ mode, close, isMobile }: Props) {
  const isActive = useSelector((state) =>
    isMobile
      ? isSidebarTabActive(state, TAB_NAMES.RECTANGLE_STYLES)
      : isTopMenuDropdownVisible(state, TopMenuDropdown.RectangleStyles),
  );

  const dispatch = useDispatch();

  const handleClick = () => {
    if (isMobile) {
      if (isActive) {
        dispatch(setSidebarActiveTabOperation(-1));
      } else {
        dispatch(setSidebarActiveTabByNameOperation(TAB_NAMES.RECTANGLE_STYLES));
      }
    } else {
      dispatch(setActiveTopMenuDropdownOperation(TopMenuDropdown.RectangleStyles));
      close?.();
    }
  };

  return (
    <MenuButton
      Icon={IconStrokeWidth}
      on={isActive}
      mode={mode}
      handleClick={handleClick}
      label="Rectangle Styles"
      className="cy-button-rectangle-styles"
    />
  );
}

export default React.memo(ButtonRectangleStyles);
